export const isValidMobile = (mobile: string): boolean => {
    return /^\+(?:[0-9] ?){6,14}[0-9]$/?.test(mobile)
}
